import { memo, useCallback } from 'react'
import PropTypes from 'prop-types'
import { useDispatch } from 'react-redux'

import { ConfirmationDialog } from '@collaborate-health/uikit'
import { sessionTitleFormatter } from '@tabeeb/shared/utils/text'
import { deleteSessionPermanently } from '@tabeeb/modules/sessionsPage/actions'

const DeleteSessionPermanentlyDialog = ({ open, session, onClose }) => {
  const dispatch = useDispatch()

  const onSubmit = useCallback(() => {
    dispatch(deleteSessionPermanently.request({ contentId: session.Id }))

    onClose()
  }, [dispatch, session.Id, onClose])

  return (
    <ConfirmationDialog
      isOpen={open}
      title={sessionTitleFormatter.format('Delete session')}
      dialogMessage={sessionTitleFormatter.format('Are you sure you want to delete this session forever?')}
      onCloseDialog={onClose}
      onSubmit={onSubmit}
      cancelButtonText='No'
      submitButtonText='Yes'
    />
  )
}

DeleteSessionPermanentlyDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  session: PropTypes.shape({
    Id: PropTypes.number.isRequired,
  }).isRequired,
  onClose: PropTypes.func.isRequired,
}

export default memo(DeleteSessionPermanentlyDialog)
